import React from 'react';
import { MinimalClientCompany } from '../bookingOrders/types/ClientCompany';

type ClientCompanySelectOptionProps = {
  clientCompany: MinimalClientCompany;
};

const ClientCompanySelectOption: React.FC<ClientCompanySelectOptionProps> = ({
  clientCompany,
}) => {
  return (
    <div className="flex flex-col">
      {clientCompany.name}
      <div className="text-xs text-gray-600 w-0">
        {clientCompany.subsidiaryCompany.name}
      </div>
    </div>
  );
};

export default ClientCompanySelectOption;
